// Target element for observing DOM changes
const targetElement = document.querySelector('.product__blocks .product__block--variant_picker');

// Buy Button element
const buyButton = document.querySelector('.main-product-form .product-form__buttons span');

// Check if required elements exist
if (targetElement && buyButton) {
    // Function to append price and comparePrice to buyButton
    function appendPrices() {
      // Price and Compare Price elements
      const price = document.querySelector('.product__block .f-price-item--sale .money');
      const comparePrice = document.querySelector('.product__block .f-price-item--regular s .money');
        // Check if prices are already appended
        if (!buyButton.querySelector('.money') && !buyButton.querySelector('.button-compare-at-price')) {
            buyButton.innerHTML += ` - <span class="money">${price.innerHTML}</span> <span class="button-compare-at-price">${comparePrice.innerHTML}</span>`;
        }
    }

    function updateStock() {
      // Reload the element using .load()
      $('.pdp-scarcity-percent-new').load(window.location.href + ' .pdp-scarcity-percent-new', function (response, status, xhr) {
          if (status === "success") {
              console.log('Element reloaded successfully!');
          } else if (status === "error") {
              console.error('Error reloading element:', xhr.status, xhr.statusText);
          }
      });
    }

    // MutationObserver for detecting DOM changes
    const observer = new MutationObserver(() => {
        console.log('DOM change detected in variant picker.');
        appendPrices();
        updateStock();
    });

    // Observe the target element for changes
    observer.observe(targetElement, {
        childList: true, // Detect changes to child elements
        subtree: true,   // Detect changes in the subtree
        attributes: true // Detect attribute changes
    });

    // Initial check and append
    appendPrices();
} else {
    console.error('Required elements not found.');
}
